<template>
  <div class="article_4">
    <Navigation></Navigation>

    <div class="article_header">       
      <div class=col_1>    
        <h1 v-if="$global.global_ru">ПРАВО НА ИЗОБРАЖЕНИЕ</h1>  
        <h1 v-if="$global.global_kz">БЕЙНЕГЕ ҚҰҚЫҚ</h1> 

        <h2 v-if="$global.global_ru"><span>ЧТО ИЗМЕНИЛОСЬ:</span></h2>
        <h2 v-if="$global.global_kz"><span>Не өзгерді:</span></h2>

        <img v-if="$global.global_ru" alt="" src="../assets/pic/pravo_na_izobrajenie_1.png" /> 
        <img v-if="$global.global_kz" alt="" src="../assets/pic/kz_pravo_na_izobrajenie_1.png" />
      </div>


      <div class=col_2>
        <img alt="" src="../assets/img/04.png" /> 
      </div>
    </div>


    <div class="text_container">
      <div class="mobile_only">
        <h2 v-if="$global.global_ru"><span>ЧТО ИЗМЕНИЛОСЬ:</span></h2>
        <img v-if="$global.global_ru" alt="" src="../assets/pic/pravo_na_izobrajenie_1.png" /> 

        <h2 v-if="$global.global_kz"><span>Не өзгерді:</span></h2>       
        <img v-if="$global.global_kz" alt="" src="../assets/pic/kz_pravo_na_izobrajenie_1.png" /> 
      </div> 


    <!-- RU version main text -->
    <div v-if="$global.global_ru">    
      <h2><span>Основные проблемы:</span></h2>
      <p>Большинство опрошенных журналистов считают, что принятая норма помогает в работе журналистов. Иногда редакции получают претензии, но как правило, до суда дела не доходят. </p>  

      <p>Чаще претензии о нарушении права на собственное изображение поступают от правоохранительных органов и от частных лиц, а также связаны с публикацией изображений в судах. Не всегда обычные граждане соглашаются «позировать на камеру». </p>  

      <p>Иногда возникают проблемы со съемкой на частной территории, поэтому журналисты стараются снимать в общественных местах и делать так, чтобы человек не был главным объектом на фото.  Изображения детей в СМИ стараются ретушировать. </p>  

      <p>Лишь у немногих региональных изданий не возникают проблемы, поскольку они используют официальный фотобанк. </p>   
              
      <div class="highlight">
        <h2><span>Что делать?</span></h2>
        <ul>
            <li>Внести в статью 145 ГК РК и закон о СМИ норму о том, что не требуется согласие на фото и видео, если человек находится в общественном месте. </li>
            <li>Разрешить проведение съёмку скрытой камерой для журналистов при наличии общественного интереса.</li>  
            <li>Дать четкое разъяснение по праву на изображение в судах, внести изменения в нормы, регулирующие гласность судебного процесса.</li>   
        </ul>
      </div>
    </div>    

    <!-- KZ version main text -->
    <div v-if="$global.global_kz">    
      <h2><span>Негізгі мәселелер:</span></h2>
      <p>Сауалнамаға қатысқан журналистердің дені бекітілген нормалар журналистердің жұмысына көп көмегін тигізеді. Кейде редакцияларға шағым түседі, алайда іс сотқа жетпейді. </p>  

      <p>Жеке бейнеге қатысты құқық бұзушылық жөніндегі шағымдар көп жағдайда құқық қорғау органдары мен сотта түсірілген суреттердегі жеке адамдан түсіп жатады. Қарапайым адамдар көп жағдайда камераға түсуге аса құлық таныта бермейді. </p>  

      <p>Кейде жеке аумақтарда түсірімдерге қатысты дау туындап жатады, сондықтан журналистер көбінесе қоғамдық орындарды басты объект ретінде адамдарды емес, жалпы көріністерді түсіреді. БАҚ беттерінде балалар суретін мозайкамен жасыруға тырысады.  </p>  

      <p>Тек көптеген аймақтық басылымдарда ондай мәселе туындамайды, өйткені олар ресми фотобанктерге жүгінеді. </p>   
              
      <div class="highlight">
        <h2><span>Не істеуге болады?</span></h2>
        <ul>
            <li> ҚР АК 145-бабы мен БАҚ туралы заңға қоғамдық орында жүрген адамнан суретке не видеоға түсіру үшін рұқсат сұратпайтын норманы енгізу керек.</li>
            <li>Қоғамдық мүдде үшін журналистерге жасырын камера қолдануға рұқсат берген жөн</li>  
            <li>Соттағы бейнеге құқық бойынша нақты түсініктеме беріп, сот процесі ашықтығын реттейтін нормаларға өзгертулер енгізу керек.</li>   
        </ul>
      </div>
    </div>


    </div>
    <Footer></Footer>
  </div>
</template>

<script>
import Navigation from "@/components/imageNavigation.vue";
import Footer from "@/components/Footer.vue";

import { scale } from "../assets/js/variables.js"


export default {
  components: {
    Navigation, Footer  
    },
     mounted(){
      var imageNav = document.querySelector(".imageNav");
      var item = imageNav.querySelector(".choose_article");
      var imageIcons = item.getElementsByClassName("article-item");           
      imageIcons[3].style.transform = scale;         
    }
  }
</script>


<style lang="scss" scoped>
    $color: #2a62a8;

.article_header {
        background-color:$color;

  h2 span {
        background-color: white;
        color: $color;
  }
}

.text_container {
  h2 span {
        background-color: $color;
  }

  p.qoute {   
        color: $color;
        border-left: 5px solid $color;
  }  
}   


.highlight {      
      background-color: #2a62a833;
    }

 ul li:before {      
      color: $color;      
    }
</style>
